module.exports = __webpack_public_path__ + "img/baas_37.f4c6ec94.png";